import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { LoadingComponent } from '@shared/components/loading/loading.component';
import { ModalTemplateDirective } from '@shared/components/modal/modal-template.directive';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ToastComponent } from '@shared/components/toast/toast.component';
import { appName } from '@shared/constants/app-name';
import { MaintenancePageComponent } from '@shared/pages/maintenance-page/maintenance-page.component';
import { MaintenanceService } from '@shared/services/maintenance.service';
import { UserpilotService } from '@shared/services/userpilot.service';
import { HeaderComponent } from './components/header/header.component';

@Component({
  selector: 'app-root',
  styleUrls: ['app.component.scss'],
  templateUrl: 'app.component.html',
  imports: [
    LoadingComponent,
    ModalTemplateDirective,
    ModalComponent,
    ToastComponent,
    HeaderComponent,
    RouterOutlet,
    FooterComponent,
    MaintenancePageComponent,
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly userpilotService = inject(UserpilotService);
  public readonly maintenanceService = inject(MaintenanceService);

  public ngOnInit() {
    (window as any).appName = appName.lenderHub;
    this.userpilotService.run();
  }

  public ngOnDestroy(): void {
    this.userpilotService.stop();
  }
}
